import StickerSetter from '../setters/sticker';

import GraphicCreator from './abstract/graphic';

module.exports = StickerCreator;

function StickerCreator () {}

StickerCreator.prototype = new GraphicCreator();
StickerCreator.prototype.constructor = StickerCreator;

StickerCreator.prototype.initialize = function () {
  GraphicCreator.prototype.initialize.call(this);

  this.mandatory = ['sticker_id'];
  _.extend(this.defaults, {
    sticker_id: null,
    thumb_src: 'https://static.inkive.com/assets/img/placeholders/imageplaceholder_new.svg',
    smart_asset: null
  });
};

StickerCreator.prototype.create = function (data) {
  const element = this.canvas.addElement('sticker', this.getAddData(data));
  INKIVE.SVGElementLoading.show(document.getElementById(element.id));

  if (data.svg_url) {
    if (data.svg_url.endsWith('.svg')) {
      this.fetchSvgUrlContent(element, data);
    } else if (data.is_external) {
      StickerSetter.prototype.resizeExternalSticker(element, data);
    }
  } else {
    data.content || !data.sticker_id || this.fetchContent(element, data);
    data.content && this.updateContent(element, data);
  }

  this._requiresAttribution(data) && this._createAttribution(data.licence);
  this.trigger('', element.getAttribute('id'));

  if (typeof data.selected === 'undefined' || data.selected) {
    this.canvas.clearSelection();
    this.canvas.selectOnly([document.getElementById(element.id)]);
  }

  return element.getAttribute('id');
};

StickerCreator.prototype._requiresAttribution = function (data) {
  return data.licence && data.licence.attribution_licence &&
    !isAlreadyMentioned.call(this);

  function isAlreadyMentioned () {
    const ak = this._getAttributionKey(data.licence);
    return _.any($('#svgcontent > .main a[attribution]'), function (el) {
      return el.getAttribute('attribution') === ak;
    });
  }
};

StickerCreator.prototype._createAttribution = function (licence) {
  const height = this.canvas.contentH * 0.04;
  const margin = this.canvas.contentW * 0.02;
  const yOffset = $('#svgcontent > .main a[attribution]').length * height;
  const y = this.canvas.contentH - height - yOffset;

  const background = this.canvas.addSvgElementFromJson({
    element: 'rect',
    attr: {
      x: 0,
      y,
      width: this.canvas.contentW,
      height,
      fill: '#FFFFFF'
    }
  });

  const text = this.canvas.addElement('textarea', {
    x: margin,
    y: y + height / 5,
    width: this.canvas.contentW - margin * 2,
    text: {
      font_size: height / 2,
      font_family: 'Lato',
      textContent: 'Icons created by ' + licence.author_name + ' - ' + licence.author_url
    }
  });

  this.canvas.selectOnly([background, text]);
  this.canvas.groupSelectedElements('a', INKIVE.Helpers.isUrlValid(licence.author_url)
    ? licence.author_url
    : 'https://' + licence.author_url
  );

  this.canvas.getSelectedElems()[0].setAttribute(
    'attribution', this._getAttributionKey(licence)
  );
};

StickerCreator.prototype._getAttributionKey = function (licence) {
  return licence.author_name + ' ' + licence.author_url;
};

StickerCreator.prototype.fetchContent = function (element, data) {
  const updateContent = _.partial(this.updateContent, element);

  INKIVE.Helpers.api('search/sticker', 'GET', { id: data.sticker_id }, _.bind(function (result) {
    updateContent(_.extend(data, { content: result.content }));

    const newElement = document.getElementById(element.id);

    svgedit.sanitize.sanitizeSvgColor(newElement);

    if (typeof data.selected === 'undefined' || data.selected) {
      this.canvas.clearSelection();
      this.canvas.selectOnly([newElement]);
    }

    $(newElement).find('.textarea').each(function () {
      svgedit.sanitize.sanitizeSvg(this);
    });

    data.thumb_src = INKIVE.ImagesFactory.getOriginalUrl(data.thumb_src);
    this.trigger('thumb_src', element.getAttribute('id'), data);
    this.trigger('', element.getAttribute('id'));
    INKIVE.SVGElementLoading.hide(newElement);
    data.is_icon && $(newElement).toggleClass('sticker icon');

    if (data.placeholder) {
      INKIVE.DesignFacade.handle('sticker', 'convertToLayoutBox', newElement);
    }
  }, this));
};

StickerCreator.prototype.fetchSvgUrlContent = function (element, data) {
  const updateContent = _.partial(this.updateContent, element);

  $.ajax({
    url: data.svg_url,
    dataType: 'text',
    success: _.bind(function (result) {
      this.canvas.selectOnly([element]);

      try {
        $.parseXML(result);
        updateContent(_.extend(data, { content: Base64.encode(result) }));
        this.canvas.clearSelection();
        (typeof data.selected === 'undefined' || data.selected) &&
        this.canvas.selectOnly([document.getElementById(element.id)]);
        this.trigger('', element.getAttribute('id'));
      } catch (e) {
        INKIVE.DesignFacade.handle(element.id, 'delete');
        INKIVE.DesignFacade.create('icon', data);
      }
    }, this)
  });
};

StickerCreator.prototype.getAddData = function (data) {
  const getDefinedData = _.bind(this.getDefinedData, this, data);

  return {
    x: getDefinedData('position.x'),
    y: getDefinedData('position.y'),
    url: getDefinedData('thumb_src'),
    width: getDefinedData('size.width'),
    height: getDefinedData('size.height'),
    favouiritesId: data.sticker_id,
    replacementId: data.replacement_id,
    placeholder: data.placeholder,
    banner: data.banner,
    smart_asset: data.smart_asset
  };
};
